import dayjs from 'dayjs'
import vueI18n from '@plugins/vue-i18n'
import DateFormatToken from '@/constants/date/DateFormatToken'
import { DurationUnits } from '@/constants/date/DurationUnits'
export default class LocationRestriction {
  constructor({
    clientName,
    dateFrom,
    dateUntil,
    firstOfRestriction,
    id,
    isCurrentlyActive,
    lengthDays,
    locationID,
    locationName,
    message,
    ownerId,
    ownerName,
    postcode,
    previousRestrictions,
    restriction,
    status,
  } = {}) {
    /** @type {string} */
    this.clientName = clientName

    /** @type {dayjs.Dayjs} */
    this.dateFrom = dayjs(dateFrom)

    /** @type {dayjs.Dayjs} */
    this.dateUntil = dayjs(dateUntil)

    /** @type {boolean} */
    this.firstOfRestriction = firstOfRestriction

    /** @type {Number} */
    this.id = id

    /** @type {boolean} */
    this.isCurrentlyActiive = isCurrentlyActive

    /** @type {number} */
    this.lengthDays = lengthDays

    /** @type {number} */
    this.locationID = locationID

    /** @type {string} */
    this.locationName = locationName

    /** @type {string} */
    this.message = message

    /** @type {number} */
    this.ownerId = ownerId

    /** @type {string} */
    this.ownerName = ownerName

    /** @type {string} */
    this.postcode = postcode

    /** @type {number} */
    this.previousRestrictions = previousRestrictions

    /** @type {'booking.create'} */
    this.restriction = restriction

    /** @type {'ACTIVE' | 'UPCOMING' | 'PAST'} */
    this.status = status
  }

  /**
   * Returns whether this location restriction has the default message set.
   * The default message is created by the static 'createDefaultMessage(date)' method on this class
   * @return {boolean}
   */
  get hasDefaultMessage() {
    const createDefaultMessage = (date) => {
      const formattedDate = dayjs(date)
        .locale(vueI18n.locale)
        .format(DateFormatToken.LL)
      return vueI18n.t('locationRestrictions.create.defaultMessage', {
        date: formattedDate,
      })
    }
    return this.message === createDefaultMessage(this.dateUntil)
  }

  /**
   * Creates a default message for the location restriction. If date is null it will make the until date tomorrow
   * @param date {?date}
   * @return {VueI18n.TranslateResult}
   */
  static createDefaultMessage(date) {
    const usedDate = date ?? dayjs().add(1, DurationUnits.DAY)
    const formattedDate = dayjs(usedDate)
      .locale(vueI18n.locale)
      .format(DateFormatToken.LL)
    return vueI18n.t('locationRestrictions.create.defaultMessage', {
      date: formattedDate,
    })
  }
}
